<template>
  <div class="wizard-info-card" :class="variantClass">
    <i :class="icon"></i>
    <span>
      <slot />
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(defineProps<{
  icon?: string;
  variant?: string;
}>(), {
  icon: 'pi pi-info-circle',
  variant: 'secondary',
})

const variantClass = computed((): string => `variant-${props.variant}`)
</script>

<style scoped>
.wizard-info-card {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 20px;
  border-radius: 12px;
  font-size: 13px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.wizard-info-card i {
  font-size: 18px;
  flex-shrink: 0;
}

.wizard-info-card span {
  line-height: 1.5;
}

.variant-secondary {
  background: linear-gradient(
    135deg,
    var(--tenant-secondary-color),
    var(--tenant-secondary-hover-color, var(--tenant-secondary-color))
  );
  border: 1px solid var(--tenant-secondary-hover-color, var(--tenant-secondary-color));
  color: #ffffff;
}

.variant-secondary i {
  color: #ffffff;
}

.variant-warning {
  background: linear-gradient(135deg, rgba(245, 158, 11, 0.08) 0%, rgba(245, 158, 11, 0.04) 100%);
  border: 1px solid rgba(245, 158, 11, 0.2);
  color: var(--text-color);
}

.variant-warning i {
  color: #f59e0b;
}
</style>
